import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	background-color: #f3f3f3;

	.header-mobile {
		display: none;
	}

	@media all and (max-width: ${vars.mobileL}) {
		.header-mobile {
			background-color: ${vars.colorBackgroundContrast};
			padding: 0.6em;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.logo {
			height: 4.5em;
			margin: 0 auto;
			max-width: 60%;
		}

		.layout-default {
			.public-layout-navigation-topbar-mobile {
				display: none;
			}
		}
	}
`;
